import { styled } from '@linaria/react';

import { normalize, roundTo } from '@/utils';

interface Props {
  headroom: number;
  hoveredPoint: { x: number; y: number };
  rawPoint: number | string;
}

function PointLabel({ headroom, hoveredPoint, rawPoint }: Props) {
  // Alright, so `hoveredPoint.y` is a number from 0 to (100 + headroom). For example, if the chart has 40px of headroom and the hovered point is way at the bottom, it would be `140)`.
  // These values are in pixels, but specifically in VIEWBOX pixels, so we can't use them as-is. We need to use percentages.
  const yPercentage = normalize(
    hoveredPoint.y,
    0,
    100 + headroom,
    0,
    100
  );

  return (
    <Wrapper
      draggable={false}
      style={{
        top: yPercentage + '%',
        left: hoveredPoint.x + '%',
      }}
    >
      {getFormattedValue(rawPoint)}
    </Wrapper>
  );
}

const getFormattedValue = (rawPoint: number | string) => {
  if (typeof rawPoint === 'number') {
    return rawPoint / 100;
  }

  const [y, x] = rawPoint.split(' ');

  return `${roundTo(Number(y) / 100, 3)} ${x}`;
};

const Wrapper = styled.div`
  position: absolute;
  white-space: nowrap;
  transform: translate(-50%, calc(-100% - 16px));
  background: var(--color-background);
  user-select: none;
  font-size: 0.75rem;
  font-family: var(--font-family-mono);
  font-weight: 500;
  color: var(--wham-primary-500);
  padding: 2px 4px;
  border-radius: 4px;
  pointer-events: none;
  animation: fadeFromTransparent 500ms;
  outline: 1px solid var(--color-gray-300);
  opacity: 1;
  transition:
    opacity 100ms,
    color 100ms;
`;

export default PointLabel;
